import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getClientId, getCriticalityLabels } from 'src/module/authentication/selector';
import { getDevicesSelectedFilters } from 'src/module/filter/selector';
import { fetchDeviceList, fetchDeviceListNextPage } from 'src/module/deviceList/action';
import {
  getDeviceListError,
  getDeviceListHasMore,
  getDeviceListItems,
  getDeviceListLoading
} from 'src/module/deviceList/selector';
import type { DeviceListScope } from 'src/service/api/deviceList';
import { toDeviceListRows } from './deviceListRows';

export default function useDeviceList (sort: string, scope?: DeviceListScope) {
  const dispatch = useDispatch();

  const clientId = useSelector(getClientId);
  const selectedFilters = useSelector(getDevicesSelectedFilters);
  const labels = useSelector(getCriticalityLabels);
  const items = useSelector(getDeviceListItems);
  const loading = useSelector(getDeviceListLoading);
  const hasMore = useSelector(getDeviceListHasMore);
  const error = useSelector(getDeviceListError);

  const filtersHash = selectedFilters.hashCode();
  const panelId = scope?.panelId;
  const controllerId = scope?.controllerId;

  useEffect(() => {
    dispatch(fetchDeviceList(selectedFilters, sort, scope));
  }, [dispatch, clientId, filtersHash, sort, panelId, controllerId]);

  const rows = useMemo(() => toDeviceListRows(items, labels), [items, labels]);
  const onLoadMore = useCallback(() => dispatch(fetchDeviceListNextPage()), [dispatch]);

  const filtered = selectedFilters.some(Boolean);

  return { rows, loading, hasMore: hasMore && !error, onLoadMore, error, filtered };
}
